import { pick } from 'underscore';
import { Dimensions } from 'types/common';
import { Pixels } from 'utils/measurement';
import {
  fitElement,
  isFill,
  measurementToPx,
  measurementToViewport,
} from 'utils/placement';
import { TemplateAction } from '../../action-types';
import { VideoTemplateStateContent } from '../../types';
import {
  addWatermark,
  recropWatermark,
  scaleWatermark,
  setInitialWatermarkPlacement,
  updateWatermark,
} from './mutations';

export default function reducer(
  state: VideoTemplateStateContent,
  action: TemplateAction,
): VideoTemplateStateContent {
  switch (action.type) {
    case 'WATERMARK_LAYER_DOUBLE_CLICK': {
      const { canvas, watermark } = state;
      const canvasPx = {
        height: new Pixels(canvas.height),
        width: new Pixels(canvas.width),
      };
      const placement: Dimensions<Pixels> = measurementToPx(
        {
          ...watermark.position,
          ...watermark.size,
        },
        canvas,
      );

      const newPlacement = fitElement(
        placement,
        canvasPx,
        isFill(placement, canvasPx) ? 'fit' : 'fill',
      );

      const newPlacementVp = measurementToViewport(newPlacement, canvasPx);

      return updateWatermark(state, {
        position: pick(newPlacementVp, 'left', 'top'),
        size: pick(newPlacementVp, 'height', 'width'),
      });
    }

    case 'WATERMARK_ADD':
      return addWatermark(state, action.payload);

    case 'WATERMARK_CROP': {
      const { src, metadata } = action.payload;
      return recropWatermark(state, src, metadata);
    }

    case 'WATERMARK_DELETE': {
      return {
        ...state,
        watermark: undefined,
      };
    }

    case 'WATERMARK_LOAD': {
      const { naturalSize } = action.payload;
      return setInitialWatermarkPlacement(state, naturalSize);
    }

    case 'WATERMARK_PLACEMENT_CHANGE': {
      const { height, left, top, width } = action.payload;
      const { canvas } = state;

      return updateWatermark(state, {
        position: measurementToViewport({ left, top }, canvas),
        size: measurementToViewport({ height, width }, canvas),
      });
    }

    case 'WATERMARK_LAYER_WHEEL': {
      const event = action.payload;
      return scaleWatermark(state, event.deltaY * 0.001);
    }

    case 'WATERMARK_UPDATE': {
      return updateWatermark(state, action.payload);
    }

    default:
      return state;
  }
}
